import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { setHousePhotoAction } from "../../../store/actions/ad/adActions";

const ImageWithOnError = ({ src, adHousePhotos, onError, ...imageProps }) => {
  const dispatch = useDispatch();
  const selectedPhotos = adHousePhotos || [];
  const selectedIndex = selectedPhotos.indexOf(src);

  return (
    <div
      onClick={() => dispatch(setHousePhotoAction(src))}
      className={`choose-listing-card ${
        selectedIndex > -1 ? "active" : ""
      }`}>
      <span className="choose-listing-card-count">
        {selectedIndex > -1 ? selectedIndex + 1 : ""}
      </span>
      <div className="choose-listing-card-img-cnt">
        <img {...imageProps} src={src} onError={() => onError(src)} />
      </div>
    </div>
  );
};

ImageWithOnError.propTypes = {
  src: PropTypes.string.isRequired,
  adHousePhotos: PropTypes.array,
  onError: PropTypes.func.isRequired,
};

export default ImageWithOnError;
